import React, { Component } from 'react';

import { IUserInformationFormComponentProps } from '../types/props';
import { IValidatedForm } from '../types/states';
import './userInformationForm.component.scss';
import { ECartSSAWorkflow } from '../enums';
class UserInformationFormComponent extends Component<
  IUserInformationFormComponentProps,
  IValidatedForm
> {
  constructor(props: null) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  isDesignationChecked = (designation: string) => {
    return this.props.userInfo.advisorDesignations.indexOf(designation) > -1;
  };

  updateClientName = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    this.props.updateUserInfo(
      Object.assign({}, this.props.userInfo, {
        clientName: event.target.value,
      })
    );
  };

  updateAdvisorName = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    this.props.updateUserInfo(
      Object.assign({}, this.props.userInfo, {
        advisorName: event.target.value,
      })
    );
  };

  updateAdvisorPhone = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    this.props.updateUserInfo(
      Object.assign({}, this.props.userInfo, {
        advisorPhone: event.target.value,
      })
    );
  };

  updateDesignations = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    const DESIGNATION_NAME = event.target.name;
    // Because browsers will render HTML entities in HTML attributes like name,
    // we need to handle them independently
    const containsRball = [
      'APMA',
      'CFP',
      'CFA',
      'ChFC',
      'CLU',
      'CRPC',
      'CIMA',
      'CMFC',
    ].includes(DESIGNATION_NAME);
    const DESIGNATION = DESIGNATION_NAME + (containsRball ? '&reg;' : '');

    const DESIGNATIONS = [...this.props.userInfo.advisorDesignations];
    if (event.target.checked) {
      DESIGNATIONS.push(DESIGNATION);
    } else {
      const INDEX = DESIGNATIONS.indexOf(DESIGNATION);
      DESIGNATIONS.splice(INDEX, 1);
    }
    this.props.updateUserInfo(
      Object.assign({}, this.props.userInfo, {
        advisorDesignations: DESIGNATIONS,
      })
    );
  };

  updateCustomDesignation = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    this.props.updateUserInfo(
      Object.assign({}, this.props.userInfo, {
        advisorCustomDesignation: event.target.value,
      })
    );
  };

  validate = () => {
    this.setState({
      hasError: this.props.clientNameRequired ? !this.props.userInfo.clientName : false,
    });
  };

  errorStateClasses = (): string => {
    return this.state.hasError ? 'error-message has-error' : 'error-message';
  };

  updateIncludeHistoricalPerformanceData = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    this.props.updateUserInfo(
      Object.assign({}, this.props.userInfo, {
        includeHistoricalPerformanceData: event.target.checked,
      })
    );
  };

  updateIncludeCurrentRatesData = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    this.props.updateUserInfo(
      Object.assign({}, this.props.userInfo, {
        includeCurrentRatesData: event.target.checked,
      })
    );
  };

  render() {
    return (
      <form id="challenge-pdf-user-info">
        <div className="row">
          <h3>Please enter the following information for your PDF:</h3>
        </div>
        <div className="row">
          <div className="ampri-form-input">
            <label htmlFor="clientName">
              Client name{this.props.clientNameRequired ? (<span>*</span>) : ''}
            </label>
            <input
              name="clientName"
              data-automation="global-challenges-input-client-name"
              required={this.props.clientNameRequired}
              value={this.props.userInfo.clientName}
              onChange={this.updateClientName}
              onBlur={this.validate}
            />
          </div>
        </div>
        <div className="row">
          <div className="ampri-form-input">
            <label htmlFor="advisorName">Advisor name</label>
            <input
              name="advisorName"
              data-automation="global-challenges-input-advisor-name"
              value={this.props.userInfo.advisorName}
              onChange={this.updateAdvisorName}
            />
          </div>
        </div>
        <div className="row">
          <div className="ampri-form-input">
            <label htmlFor="advisorPhone">Advisor phone number</label>
            <input
              name="advisorPhone"
              value={this.props.userInfo.advisorPhone}
              onChange={this.updateAdvisorPhone}
            />
          </div>
        </div>
        <div className="row row--flex">
          <div className="designation">
            <input
              type="checkbox"
              name="APMA"
              checked={this.isDesignationChecked('APMA&reg;')}
              onChange={this.updateDesignations}
            />
            <label htmlFor="APMA">APMA&reg;</label>
          </div>
          <div className="designation">
            <input
              type="checkbox"
              name="BFA"
              checked={this.isDesignationChecked('BFA')}
              onChange={this.updateDesignations}
            />
            <label htmlFor="BFA">BFA</label>
          </div>
          <div className="designation">
            <input
              type="checkbox"
              name="CFP"
              checked={this.isDesignationChecked('CFP&reg;')}
              onChange={this.updateDesignations}
            />
            <label htmlFor="CFP">CFP&reg;</label>
          </div>
          <div className="designation">
            <input
              type="checkbox"
              name="CFA"
              checked={this.isDesignationChecked('CFA&reg;')}
              onChange={this.updateDesignations}
            />
            <label htmlFor="CFA">CFA&reg;</label>
          </div>
          <div className="designation">
            <input
              type="checkbox"
              name="ChFC"
              checked={this.isDesignationChecked('ChFC&reg;')}
              onChange={this.updateDesignations}
            />
            <label htmlFor="ChFC">ChFC&reg;</label>
          </div>
        </div>
        <div className="row row--flex">
          <div className="designation">
            <input
              type="checkbox"
              name="CLU"
              checked={this.isDesignationChecked('CLU&reg;')}
              onChange={this.updateDesignations}
            />
            <label htmlFor="CLU">CLU&reg;</label>
          </div>
          <div className="designation">
            <input
              type="checkbox"
              name="CPA"
              checked={this.isDesignationChecked('CPA')}
              onChange={this.updateDesignations}
            />
            <label htmlFor="CPA">CPA</label>
          </div>
          <div className="designation">
            <input
              type="checkbox"
              name="CRPC"
              checked={this.isDesignationChecked('CRPC&reg;')}
              onChange={this.updateDesignations}
            />
            <label htmlFor="CRPC">CRPC&reg;</label>
          </div>
          <div className="designation">
            <input
              type="checkbox"
              name="CIMA"
              checked={this.isDesignationChecked('CIMA&reg;')}
              onChange={this.updateDesignations}
            />
            <label htmlFor="CIMA">CIMA&reg;</label>
          </div>
          <div className="designation">
            <input
              type="checkbox"
              name="CMFC"
              checked={this.isDesignationChecked('CMFC&reg;')}
              onChange={this.updateDesignations}
            />
            <label htmlFor="CMFC">CMFC&reg;</label>
          </div>
        </div>
        <div className="row">
          <div className="ampri-form-input">
            <label htmlFor="otherDesignations">Other Designations</label>
            <input
              name="otherDesignations"
              type="text"
              value={this.props.userInfo.advisorCustomDesignation}
              onChange={this.updateCustomDesignation}
            />
          </div>
          <p>Separate with a comma and a space</p>
        </div>
        {/* Conditionally show this if clientNameRequired is true */}
        {this.props.clientNameRequired ? (
            <div className="row">
              <div className="directions clearfix">
                <div className="ampri-form-legend">
                  <span>*</span> = required fields
                </div>
              </div>
              <div className={this.errorStateClasses()}>
                Please fill in all required fields
              </div>
            </div>
          ) : null
        }
        {(this.props.cartWorkflow === ECartSSAWorkflow.rates) ? (
          <div className="row">
            <div className="include-historical-performance">
              <input
                type="checkbox"
                name="includeHistoricalPerformanceData"
                checked={this.props.userInfo.includeHistoricalPerformanceData}
                onChange={this.updateIncludeHistoricalPerformanceData}
              />
              <label htmlFor="includeHistoricalPerformanceData">
                Include Hypothetical Historical Performance
              </label>
            </div>
            <p className="include-historical-performance-description">
              Not available for Annual Lock and Income Choice categories
            </p>
          </div>
        ) : null}
        {(this.props.cartWorkflow === ECartSSAWorkflow.historical) ? (
          <div className="row">
            <div className="include-current-rates">
              <input
                type="checkbox"
                name="includeCurrentRatesData"
                checked={this.props.userInfo.includeCurrentRatesData}
                onChange={this.updateIncludeCurrentRatesData}
              />
              <label htmlFor="includeCurrentRatesData">
                Include rates for indexed accounts selected
              </label>
            </div>
            <p className="include-current-rates-description">
              Not available for Annual Lock and Income Choice categories
            </p>
          </div>
        ) : null}
      </form>
    );
  }
}

export default UserInformationFormComponent;
